export enum TrackChangesActions {
  SET_ENABLED = 'SET_ENABLED',
  SET_SHOW_CHANGES = 'SET_SHOW_CHANGES',
}

export function setTrackChangesStatus(status: boolean) {
  return {
    type: TrackChangesActions.SET_ENABLED,
    payload: {
      enabled: status,
    },
  }
}

export function setShowChanges(payload: boolean) {
  return {
    type: TrackChangesActions.SET_SHOW_CHANGES,
    payload: { showChanges: payload },
  }
}
